
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as TrashIcon } from "../fontello/icons/svg/ic_trash.svg"


const Trash = ({ ...props }) => (
  <SvgIcon
    component={TrashIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Trash
